"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlService = void 0;
var tslib_1 = require("tslib");
/* eslint-disable no-prototype-builtins */
var webexUI_1 = require("webexUI");
var PLUS_SING_ENCODED_EXP = /%2B/gi;
var SPACE_SIGN_ENCODE_SYMBOL = '%20';
var WHITESPACE_CHARACTERS_EXP = /\s/g;
var UrlService = /** @class */ (function () {
    function UrlService() {
        var _this = this;
        // used only to read
        this.regexFileUrl = /^([\S]+)(\.(pdf|zip|dwg|dxf|((doc|ppt|xls)(x?))))(\?[\S]+)?$/i;
        this.matchExtension = /(\.(pdf|zip|dwg|dxf|((doc|ppt|xls)(x?))))(\?[\S]+)?$/i;
        this.CreateQueryObject = function (pairs) {
            return webexUI_1.safe(pairs).reduce(function (acc, next) {
                var _a;
                if (!next.key) {
                    return acc;
                }
                return tslib_1.__assign(tslib_1.__assign({}, acc), (_a = {}, _a[next.key] = next.value, _a));
            }, {});
        };
        this.isUrlParameterChanged = function (obj) {
            var urlObj = _this.GetObjectFromUrlString();
            return !!_this.isValueChanged(obj.value, urlObj[obj.key]);
        };
        this.isFilterSelected = function (filter) {
            var urlObject = _this.GetObjectFromUrlString();
            return !(!urlObject.filter || urlObject.filter.indexOf(filter) === -1);
        };
        this.GetSourceUrl = function () {
            var location = window.location;
            var origin = location.origin ||
                location.protocol + "//" + location.hostname + (location.port ? ':' + location.port : '');
            var isWindiwLocationSearch = window.location.search
                ? window.location.search
                : window.location.href.slice(window.location.href.indexOf('?'));
            var query = window.location.href.indexOf('?') === -1 ? '' : isWindiwLocationSearch;
            if (query.indexOf('#') !== -1) {
                query = query.slice(0, query.indexOf('#'));
            }
            return origin + window.location.pathname + query;
        };
        this.decodeFiltersForGTM = function (filter) {
            var decodedFilterParts = decodeURIComponent(filter).split(/[=:]/);
            var filterPartsCount = decodedFilterParts.length;
            if (filterPartsCount && filterPartsCount >= 2) {
                return {
                    filterCategory: decodedFilterParts[0],
                    filterOptions: decodedFilterParts[1],
                };
            }
            return null;
        };
        this.isValidUrl = function (url) {
            var pattern = new RegExp('^(https?:\\/\\/)?' +
                '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
                '((\\d{1,3}\\.){3}\\d{1,3}))' +
                '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
                '(\\?[;&a-z\\d%_.~+=-]*)?' +
                '(\\#[-a-z\\d_]*)?$', 'i');
            return !!pattern.test(url);
        };
        this.isValueChanged = function (value, previousValue) {
            return ((!previousValue && !!value) || // added new value
                (previousValue && previousValue !== value)); // page value changed
        };
        this.correctEncodeDiffBetweenFEandBE = function (value) {
            var result = value;
            if (value) {
                result = value.replace(PLUS_SING_ENCODED_EXP, SPACE_SIGN_ENCODE_SYMBOL);
            }
            return result;
        };
    }
    UrlService.prototype.GetObjectFromUrlString = function (url) {
        if (url === void 0) { url = window.location.search; }
        if (url.length === 0 || url.indexOf('=') === -1) {
            return {};
        }
        else {
            var arr = url.slice(1, url.length).split('&');
            var obj = {};
            for (var _i = 0, arr_1 = arr; _i < arr_1.length; _i++) {
                var item = arr_1[_i];
                var itemValue = item.split('=')[1];
                // Added for supporting old urls
                itemValue = this.correctEncodeDiffBetweenFEandBE(itemValue);
                obj[item.split('=')[0]] = decodeURIComponent(itemValue);
            }
            return obj;
        }
    };
    UrlService.prototype.GetStringFromUrlObj = function (obj) {
        var str = "?";
        for (var i in obj) {
            str += i + "=" + encodeURIComponent(obj[i]) + "&";
        }
        return str.slice(0, -1);
    };
    UrlService.prototype.IsUrlHasQueryKey = function (key, url) {
        if (url === void 0) { url = window.location.search; }
        if (url.length === 0 || url.indexOf('=') === -1) {
            false;
        }
        else {
            var urlParams = new URLSearchParams(url);
            return urlParams.has(key);
        }
    };
    UrlService.prototype.GetQueryValueFromUrl = function (key, url) {
        if (url === void 0) { url = window.location.search; }
        var urlParams = new URLSearchParams(url);
        if (this.IsUrlHasQueryKey(key, url)) {
            return urlParams.get(key);
        }
        return '';
    };
    UrlService.prototype.GetFilterQueryValueFromUrl = function (key) {
        var keyValueArray = this.GetQueryValueFromUrl('filter').split(',');
        var value = keyValueArray.reduce(function (acc, pair) {
            var _a = pair.split(':'), key = _a[0], value = _a[1];
            acc[key] = value;
            return acc;
        }, {})[key];
        if (!value) {
            return '';
        }
        return value;
    };
    UrlService.prototype.GetQueryObjectValueFromUrl = function (key) {
        var keyValueString = this.GetQueryValueFromUrl(key);
        if (!keyValueString) {
            return {};
        }
        var keyValueArray = keyValueString.split(',');
        return keyValueArray.reduce(function (acc, pair) {
            var _a = pair.split(':'), key = _a[0], value = _a[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    // Returns true if state was pushed
    UrlService.prototype.AddToUrl = function (obj, replace) {
        if (replace === void 0) { replace = true; }
        if (!obj.value) {
            return this.RemoveFromUrl(obj.key, replace);
        }
        var urlObj = this.GetObjectFromUrlString();
        if (!this.isValueChanged(obj.value, urlObj[obj.key])) {
            return false;
        }
        urlObj[obj.key] = obj.value;
        var urlStr = this.GetStringFromUrlObj(urlObj);
        if (replace) {
            window.history.replaceState(urlObj, null, urlStr);
            return false;
        }
        else {
            window.history.pushState(urlObj, null, urlStr);
            return true;
        }
    };
    UrlService.prototype.AddFilterToUrl = function (key) {
        if (!key) {
            return;
        }
        var prevFilter = this.GetObjectFromUrlString()['filter'];
        var newFilterValue = key + (prevFilter ? ',' + prevFilter : '');
        this.AddToUrl({
            key: 'filter',
            value: newFilterValue,
        });
    };
    UrlService.prototype.RemoveFromUrl = function (key, replace) {
        if (replace === void 0) { replace = true; }
        // returns true if state was pushed
        var urlObj = this.GetObjectFromUrlString();
        // eslint-disable-next-line @typescript-eslint/ban-types
        if (!urlObj.hasOwnProperty(key)) {
            return false;
        }
        delete urlObj[key];
        var urlStr = this.GetStringFromUrlObj(urlObj);
        if (replace) {
            window.history.replaceState(urlObj, null, urlStr.length > 0 ? urlStr : document.location.pathname);
            return false;
        }
        else {
            window.history.pushState(urlObj, null, urlStr.length > 0 ? urlStr : document.location.pathname);
            return true;
        }
    };
    UrlService.prototype.RemoveHash = function () {
        var url = window.location.href;
        if (url.includes('#')) {
            url = url.replace(/#.*$/, '');
            window.history.replaceState({}, document.title, url);
        }
    };
    UrlService.prototype.CreateQueryCsv = function (pair) {
        return {
            key: pair.key,
            value: pair.value.join(','),
        };
    };
    UrlService.prototype.ReplaceOrAddPairsOfKeyValuesInUrl = function (url, pairsOfKeysValues) {
        var urlObj = this.GetObjectFromUrlString(url);
        pairsOfKeysValues.forEach(function (_a) {
            var key = _a.key, value = _a.value;
            if (!!key && !!value) {
                urlObj[key] = value;
            }
        });
        return this.GetStringFromUrlObj(urlObj);
    };
    UrlService.prototype.isUrlToFile = function (url, needWhiteSpacesEncoding) {
        if (needWhiteSpacesEncoding === void 0) { needWhiteSpacesEncoding = false; }
        if (url) {
            var urlToFile = needWhiteSpacesEncoding
                ? url.replace(WHITESPACE_CHARACTERS_EXP, SPACE_SIGN_ENCODE_SYMBOL)
                : url;
            return this.regexFileUrl.test(urlToFile);
        }
        return false;
    };
    UrlService.prototype.GetFileExtension = function (url) {
        if (!url) {
            return null;
        }
        var ext = url.match(this.matchExtension);
        if (!ext || !ext.length) {
            return null;
        }
        return ext[2] || ext[1] || ext[0];
    };
    return UrlService;
}());
var service = new UrlService();
exports.UrlService = service;
